import React from 'react';
import { Row, Col, Clearfix } from 'react-bootstrap';
import { ResponsiveContainer } from 'recharts';

class DashboardWidget12 extends React.Component {
  render() {
    const { title, subtitle, options, moreOptions, chart, content, bgClass, chartHeight } = this.props;

    return (
      <div className={'widget-12 card no-border no-margin widget-loader-circle ' + bgClass}>
        <div className="card-body">
          <Row>
            <Col xs={12}>
              <Clearfix>
                <h2 className="pull-left m-t-5 m-b-5">{title}</h2>
                {subtitle}
              </Clearfix>
              <Clearfix className="full-width">
                <ul className="list-inline pull-left">{options}</ul>
                {!!moreOptions &&
                  moreOptions.map((chartOptions, i) => {
                    return (
                      <div className="pull-left" key={i}>
                        <div className="pull-left m-l-10 m-r-10">|</div>
                        <ul className="pull-left list-inline">{chartOptions}</ul>
                      </div>
                    );
                  })}
              </Clearfix>
              {!!chart && <ResponsiveContainer height={chartHeight}>{chart}</ResponsiveContainer>}
              {content}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
DashboardWidget12.defaultProps = {
  options: [],
  chart: null,
  bgClass: '',
  chartHeight: 226,
};

export default DashboardWidget12;
